import script from "./transaction-filter.vue?vue&type=script&setup=true&lang=js"
export * from "./transaction-filter.vue?vue&type=script&setup=true&lang=js"

import "./transaction-filter.vue?vue&type=style&index=0&id=b6d58c02&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6d58c02"]])

export default __exports__